const benchmarking = {
  namespaced: true,
  state: {
    nationalBenchmarkData: null,
    regionalBenchmarkData: null,
    neighbourBenchmarkData: null,
    availabilityBenchmarkData: null,
    clientBenchmarkData: null,
    benchmarkPDF: null,
    loadingPDF: false,
    loadingData: []
  },
  mutations: {
    SET_NATIONAL_BENCHMARK_DATA(state, nationalBenchmarkData) {
      state.nationalBenchmarkData = nationalBenchmarkData
    },
    SET_REGIONAL_BENCHMARK_DATA(state, regionalBenchmarkData) {
      state.regionalBenchmarkData = regionalBenchmarkData
    },
    SET_NEIGHBOUR_BENCHMARK_DATA(state, neighbourBenchmarkData) {
      state.neighbourBenchmarkData = neighbourBenchmarkData
    },
    SET_AVAILABILITY_BENCHMARK_DATA(state, availabilityBenchmarkData) {
      state.availabilityBenchmarkData = availabilityBenchmarkData
    },
    SET_CLIENT_BENCHMARK_DATA(state, clientBenchmarkData) {
      state.clientBenchmarkData = clientBenchmarkData
    },
    SET_BENCHMARK_PDF(state, benchmarkPDF) {
      state.benchmarkPDF = benchmarkPDF
    },
    SET_LOADING_STATUS(state, newLoadingStatus) {
      state.loadingPDF = newLoadingStatus
    },
    SET_BENCHMARK_LOADING_STATUS(state, [newLoadingStatus, id]) {
      if (!id) throw new Error('Loading id not provided')
      let loadingData = state.loadingData
      loadingData = loadingData.filter(a => a !== id)
      if (newLoadingStatus) loadingData.push(id)
      state.loadingData = loadingData.slice()
    }
  },
  actions: {
    async fetchNationalBenchmarkData(
      { commit, state },
      { startDate = '', endDate = '' } = {},
      force
    ) {
      if (!force && !state.availabilityBenchmarkData.national) return

      commit('SET_BENCHMARK_LOADING_STATUS', [true, 'national'])
      try {
        const {
          data: nationalBenchmarkData
        } = await this.$api.fetchNationalBenchmarkData(startDate, endDate)
        commit('SET_NATIONAL_BENCHMARK_DATA', nationalBenchmarkData)
        commit('SET_BENCHMARK_LOADING_STATUS', [false, 'national'])
      } catch (err) {
        commit('FETCH_ERROR', { name: 'getBenchmarks', err, date: Date.now() })
        commit('SET_BENCHMARK_LOADING_STATUS', [false, 'national'])
      }
    },
    async fetchRegionalBenchmarkData(
      { commit, state },
      { startDate = '', endDate = '' } = {},
      force
    ) {
      if (!force && !state.availabilityBenchmarkData.regional) return

      commit('SET_BENCHMARK_LOADING_STATUS', [true, 'regional'])
      try {
        const {
          data: regionalBenchmarkData
        } = await this.$api.fetchRegionalBenchmarkData(startDate, endDate)
        commit('SET_REGIONAL_BENCHMARK_DATA', regionalBenchmarkData)
        commit('SET_BENCHMARK_LOADING_STATUS', [false, 'regional'])
      } catch (err) {
        commit('FETCH_ERROR', { name: 'getBenchmarks', err, date: Date.now() })
        commit('SET_BENCHMARK_LOADING_STATUS', [false, 'regional'])
      }
    },
    async fetchNeighbourBenchmarkData(
      { commit, state },
      { startDate = '', endDate = '' } = {},
      force
    ) {
      if (!force && !state.availabilityBenchmarkData.neighbour) return

      commit('SET_BENCHMARK_LOADING_STATUS', [true, 'neighbour'])
      try {
        const {
          data: neighbourBenchmarkData
        } = await this.$api.fetchNeighbourBenchmarkData(startDate, endDate)
        commit('SET_NEIGHBOUR_BENCHMARK_DATA', neighbourBenchmarkData)
        commit('SET_BENCHMARK_LOADING_STATUS', [false, 'neighbour'])
      } catch (err) {
        commit('FETCH_ERROR', { name: 'getBenchmarks', err, date: Date.now() })
        commit('SET_BENCHMARK_LOADING_STATUS', [false, 'neighbour'])
      }
    },
    async fetchClientBenchmarkData(
      { commit, state },
      { startDate = '', endDate = '' } = {},
      force
    ) {
      if (!force && !state.availabilityBenchmarkData.self) return

      commit('SET_BENCHMARK_LOADING_STATUS', [true, 'self'])
      try {
        const {
          data: clientBenchmarkData
        } = await this.$api.fetchClientBenchmarkData(startDate, endDate)
        commit('SET_CLIENT_BENCHMARK_DATA', clientBenchmarkData)
        commit('SET_BENCHMARK_LOADING_STATUS', [false, 'self'])
      } catch (err) {
        commit('FETCH_ERROR', { name: 'getBenchmarks', err, date: Date.now() })
        commit('SET_BENCHMARK_LOADING_STATUS', [false, 'self'])
      }
    },
    async fetchBenchmarkPDF(
      { commit },
      { comparisonFilter, startDate, endDate }
    ) {
      commit('SET_LOADING_STATUS', true)
      try {
        const { data: benchmarkPDF } = await this.$api.fetchBenchmarkPDF(
          comparisonFilter,
          startDate,
          endDate
        )
        const url = window.URL.createObjectURL(new Blob([benchmarkPDF]))
        const link = document.createElement('a')
        link.href = url
        link.target = '_blank'
        link.setAttribute('download', 'benchmarking.pdf')
        document.body.appendChild(link)
        link.click()
        commit('SET_BENCHMARK_PDF', benchmarkPDF)
        commit('SET_LOADING_STATUS', false)
      } catch (err) {
        commit('FETCH_ERROR', {
          name: 'getBenchmarkPDF',
          err,
          date: Date.now()
        })
        commit('SET_LOADING_STATUS', false)
      }
    },
    async fetchAvailabilityBenchmarkData({ commit, dispatch }) {
      try {
        commit('SET_BENCHMARK_LOADING_STATUS', [true, 'availability'])
        const {
          data: availabilityBenchmarkData
        } = await this.$api.fetchAvailabilityBenchmarkData()
        commit('SET_AVAILABILITY_BENCHMARK_DATA', availabilityBenchmarkData)
        commit('SET_BENCHMARK_LOADING_STATUS', [false, 'availability'])

        dispatch('fetchClientBenchmarkData')
        if (availabilityBenchmarkData.national) { dispatch('fetchNationalBenchmarkData') } else if (availabilityBenchmarkData.regional) { dispatch('fetchRegionalBenchmarkData') } else if (availabilityBenchmarkData.neighbour) { dispatch('fetchNeighbourBenchmarkData') }
      } catch (err) {
        console.error(err)
        commit('FETCH_ERROR', { name: 'getBenchmarks', err, date: Date.now() })
      }
    }
  },
  getters: {
    nationalBenchmarkData: state => state.nationalBenchmarkData,
    regionalBenchmarkData: state => state.regionalBenchmarkData,
    clientBenchmarkData: state => state.clientBenchmarkData,
    neighbourBenchmarkData: state => state.neighbourBenchmarkData,
    availabilityBenchmarkData: state => state.availabilityBenchmarkData,
    benchmarkPDF: state => state.benchmarkPDF,
    loadingPDF: state => state.loadingPDF,
    loadingData: state => !!state.loadingData.length
  }
}

export default benchmarking
